import React, { useRef } from "react";
import Select from "react-select";

import CashOutVendorField from "./CashOutVendorField";
import CashEntryAttachments from "./CashEntryAttachments";

const CashOutEntryRow = ({
  row,
  disabled,
  categoriesLoading,
  categoryOptions,
  paymentModeOptions,
  updateRow,
  onRemoveRow,
  canRemoveRow
}) => {
  const inputRef = useRef(null);

  return (
    <div className="cash-out-entry-row mb-3">
      {/* First row */}
      <div className="row g-2 align-items-end">
        <div className="form-group col-12 col-md-6 col-xl-3">
          <label
            htmlFor={`cash-out-date-${row.id}`}
            className="form-label"
          >
            Date & Time
          </label>

          <input
            id={`cash-out-date-${row.id}`}
            type="datetime-local"
            className="form-control"
            value={row.dateTime}
            disabled={disabled}
            onChange={(event) =>
              updateRow(row.id, "dateTime", event.target.value)
            }
          />
        </div>

        <div className="form-group col-12 col-md-6 col-xl-3">
          <label
            htmlFor={`cash-out-category-${row.id}`}
            className="form-label"
          >
            Category
          </label>

          <Select
            inputId={`cash-out-category-${row.id}`}
            options={categoryOptions}
            value={
              categoryOptions.find(
                (option) => option.value === row.categoryId
              ) || null
            }
            onChange={(selected) =>
              updateRow(row.id, "categoryId", selected?.value || "")
            }
            placeholder={
              categoriesLoading ? "Loading Categories..." : "Select Category"
            }
            isSearchable
            isClearable
            isLoading={categoriesLoading}
            isDisabled={disabled || categoriesLoading}
            noOptionsMessage={() => "No cash out categories found"}
            className="erp-select"
            classNamePrefix="erp-select"
            menuPlacement="auto"
          />
        </div>

        <div className="form-group col-12 col-md-4 col-xl-2">
          <label
            htmlFor={`cash-out-amount-${row.id}`}
            className="form-label"
          >
            Amount (₹)
          </label>

          <input
            id={`cash-out-amount-${row.id}`}
            type="number"
            className="form-control"
            min="0"
            step="0.01"
            placeholder="Amount"
            value={row.amount}
            disabled={disabled}
            onWheel={(event) => event.currentTarget.blur()}
            onChange={(event) =>
              updateRow(row.id, "amount", event.target.value)
            }
          />
        </div>

        <div className="form-group col-12 col-md-4 col-xl-2">
          <label
            htmlFor={`cash-out-payment-mode-${row.id}`}
            className="form-label"
          >
            Payment Mode
          </label>

          <Select
            inputId={`cash-out-payment-mode-${row.id}`}
            options={paymentModeOptions}
            value={
              paymentModeOptions.find(
                (option) => option.value === row.paymentMode
              ) || null
            }
            onChange={(selected) =>
              updateRow(row.id, "paymentMode", selected?.value || "")
            }
            placeholder="Select Mode"
            isDisabled={disabled}
            isSearchable={false}
            className="erp-select"
            classNamePrefix="erp-select"
            menuPlacement="auto"
          />
        </div>

        <div className="form-group col-12 col-md-4 col-xl-2">
          <label
            htmlFor={`cash-out-vendor-${row.id}`}
            className="form-label"
          >
            Vendor Name
          </label>

          <CashOutVendorField
            rowId={row.id}
            value={row.vendorId}
            disabled={disabled}
            onChange={(vendorId) =>
              updateRow(row.id, "vendorId", vendorId)
            }
          />
        </div>
      </div>

      {/* Second row */}
      <div className="row g-2 align-items-end mt-1">
        <div className="form-group col-12 col-md-4 col-xl-3">
          <label
            htmlFor={`cash-out-voucher-${row.id}`}
            className="form-label"
          >
            Voucher No / Transaction ID
          </label>

          <input
            id={`cash-out-voucher-${row.id}`}
            type="text"
            className="form-control"
            placeholder="Voucher No / Transaction ID"
            value={row.voucherNo || ""}
            disabled={disabled}
            onChange={(event) =>
              updateRow(row.id, "voucherNo", event.target.value)
            }
          />
        </div>

        <div className="form-group col-12 col-md-8 col-xl-4">
          <label
            htmlFor={`cash-out-remark-${row.id}`}
            className="form-label"
          >
            Remark
          </label>

          <input
            id={`cash-out-remark-${row.id}`}
            type="text"
            className="form-control"
            placeholder="Enter remark"
            value={row.remark || ""}
            disabled={disabled}
            onChange={(event) =>
              updateRow(row.id, "remark", event.target.value)
            }
          />
        </div>

        <div className="col-12 col-xl-5">
          <CashEntryAttachments
            inputRef={inputRef}
            attachments={row.attachments || []}
            disabled={disabled}
            onChange={(attachments) =>
              updateRow(row.id, "attachments", attachments)
            }
            onRemoveRow={onRemoveRow}
            canRemoveRow={canRemoveRow}
          />
        </div>
      </div>
    </div>
  );
};

export default CashOutEntryRow;